import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';
import { ADMIN_NAV_WIDTH_COMPACT, ADMIN_NAV_WIDTH_EXPANDED } from '../../../web/constants/sizes';
import { BreakPoints, CssSelectors } from '../../../web/styles/styles';

const {
	spacing: { md, xl },
} = THEME;

export const HeaderHeight = 96;
export const CompactWidth = 1400;

export const styleSheet = StyleSheet.create({
	compactNav: {
		overflow: 'hidden',
		width: ADMIN_NAV_WIDTH_COMPACT,
		zIndex: 1,
		[BreakPoints.forMaxWidth(CompactWidth)]: {
			width: ADMIN_NAV_WIDTH_COMPACT,
		},
	},
	container: {
		background: '#fff',
		height: '100%',
		minWidth: 768,
		display: 'grid',
		gridTemplateColumns: `auto 1fr auto`,
		gridTemplateRows: '100%',
	},
	masthead: {
		height: HeaderHeight,
		padding: `0 ${xl}px`,
		[BreakPoints.forMaxWidth(CompactWidth)]: {
			padding: `0 ${md}px`,
		},
	},
	nav: {
		overflow: 'hidden',
		width: ADMIN_NAV_WIDTH_EXPANDED,
		zIndex: 1,
		flexShrink: 0,
		[BreakPoints.forMaxWidth(CompactWidth)]: {
			width: ADMIN_NAV_WIDTH_COMPACT,
		},
	},
	navHeaderBackground: {
		marginBottom: 40,
	},
	rightContainer: {
		overflowX: 'auto',
	},
	containerContent: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
	},
	rightContainerScroller: {
		height: `calc(100% - ${HeaderHeight}px)`,
	},
	rightContainerScrollerContent: {
		padding: `0 ${xl}px`,
		[BreakPoints.forMaxWidth(CompactWidth)]: {
			padding: `0 ${md}px`,
		},
		...CssSelectors.allChildren(
			{
				height: '100%',
			},
			'div'
		),
	},
});
